module.exports = __webpack_public_path__ + "static/media/sovtech-small1.5631eda7.png";